export default "/images/vendor/flag-icons/flags/1x1/es.svg?284fc0d789fb7e70a998c618024ae62b";